<template>
	<div class="pager">
		<div id="box">
			<div class="firshpage">
				<div class="text">
					<div class="texttitle"><span>被封为药王</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
					<p>&ensp;&ensp;孙思邈采用悬丝诊脉，用针灸治好了长孙皇后的难产病后，唐太宗非常高兴，赏赐他金银财宝，封他官。孙思邈都没有接受。唐太宗就封他为药中之王，并赐予他冲天翅的王冠和赭黄色的王袍。</p>
					<img src="../../assets/images/pager1img.png" />
					<p>&ensp;&ensp;开国元勋尉迟敬德听到消息后大为不悦，心想自己为唐朝打天下，屡立战功，也没有封王，孙思邈进京才几天，竟得到如此殊荣。他要追赶孙思邈，夺回王袍王冠。孙思邈预知有人要来夺王袍，就把冲天翅扳成顺天翅，把黄袍翻穿成红袍。敬德领兵追到灞桥时，见孙思邈身穿红袍，头戴顺天翅，在柳荫之下恭候。敬德感到不好意思，便改口说：我专程赶来，想讨些灵丹妙药。孙思邈送给他灵丹十八丸，保他东征胜利。后来敬德后悔自己不该妒忌，便击掌发</p>
					
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>誓，愿在孙思邈成圣后站班助威，听凭调用。此事流传民间，至今成为美谈。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>锯末治腹痛</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;孙思邈刚开始行医时，就在故乡孙家原村。有一次，邻里的一对中年夫妇抱着小孩，急急忙忙地找他看病。小孩呕吐不止，手捂腹部喊痛，父母慌得不知所措。孙思邈仔细诊断后，认为是受寒而得。这时看到旁边有一堆锯末，他忽然有所醒悟：檀香木理气止痛，其锯末也有同样效果。</p>
						<img src="../../assets/images/pager2img.png" />
						<p>&ensp;&ensp;于是他抓了一把锯末，让父亲加点生姜作为引子，当即熬药服下。夫妇半信半疑地回到家，照他说的方法煎药，孩子喝了后，果然呕停痛止，病很快就好了。夫妇俩高兴地逢人就说，孙思邈医术高明，救了小孩的命。</p>
						<p>&ensp;&ensp;从此他在乡里声名大振，得到周围村庄乡亲们的信任，一有病便纷纷前来就医。</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<img src="../../assets/images/pager2img2.png" />
						<p>&ensp;&ensp;檀香为檀香科植物檀香的心材，性味辛温，功能理气止痛，温中和胃，主治恶心呕吐，脘腹胀痛。生姜为姜科植物姜的根茎鲜品，性味辛温，功能散寒解表，温中止呕，主治畏寒呕吐，风寒表证等。两药配伍，温中止痛，理气降逆，故获良效。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>用葱叶导尿</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;孙思邈在治病过程中，处处留心，善于发现。传说有一天，华原县城东街的张先生患小便不利，听医生说是喝水少，因此就大量饮水，结果腹部憋胀，最后竟至小便点滴不出。孙思邈仔细观察病情，认定患的是“癃闭”，由尿道不通所致。如何治疗呢？他想，能不能从尿道插进一根管子，尿肯定会排出来。</p>
						<img src="../../assets/images/pager3img.png" />
						<p>可狭窄的尿道，该用哪种管子呢？急得他从院子里踱到门外，忽然看见有个小孩吹着葱叶玩，他顿时有了主意，挑出一根细长的小葱切去葱尖，顺着尿道插进，并像小孩一样用劲一吹，果然患者的尿液从葱叶中流了出来，腹部憋胀马上得到缓解，病情随之痊愈。病人直起身来，连连向他道谢说：“救命之恩，终身难忘。”于是“葱叶导尿”被记载在他的书</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>中。</p>
						<p>&ensp;&ensp;这是我国记载最早的导尿方法，也是导尿管从此产生的缘由。而“癃闭”病采用导尿方法仅是权宜之计，并非根本治法。此病多是由于热淋或石淋引起，只要清热排石就可治愈。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>琥珀救产妇</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;孙思邈出外行医，有一天正在行走，忽然看见一行出殡队伍迎面而来。他停在路边，忽然上前一步，按住棺材大喊：“且慢!”送殡的人以为他是疯子要赶走，他便说这人还没死，你们怎么忍心埋了呢?众人说人早死了，你不要胡说。</p>
						<img src="../../assets/images/pager4img.png" />
						<p>&ensp;&ensp;他说人要死了，血会凝固的，你们看棺材底下正在滴着鲜血。众人果然发现有血丝向外流，就打开棺材请他看。只见有个妇人面黄如纸，且怀有身孕。丈夫哭诉说结婚十年没生育，这次怀孕几月，昨天忽然胎动并大出血。</p>
						<p>&ensp;&ensp;孙思邈试了妇人的鼻息和脉象，以其鼻孔，又急取琥珀粉灌服，孕妇很快苏醒过来。他又送给病家一剂药、一幅图，嘱咐把病人抬回去，喝下这副药，再按图接生，保</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>证母子平安。后来妇人果然顺利生下个胖娃娃，于是众人把他当成了神仙，孙思邈却说：此乃琥珀之功也。</p>
						<p>&ensp;&ensp;琥珀为古代松科植物的树脂埋藏地下经久凝结而成，生于黏土层、砂层、煤层及沉积岩内。以色红、明亮、块整齐、质松脆、易碎者为佳，有蜂、蚁、松枝者尤好。性味甘平，功能镇惊安神，散瘀止血，利尿通淋，主治心悸、失眠、惊痫、闭经、小便不利等。现代药理证实琥珀酸具有抗抽搐以及镇静、降低体温、镇痛、兴奋呼吸、升高血压等作用。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
					<div class="texttitle"><span>寻找灵芝草</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
					<p>&ensp;&ensp;孙思邈在峨眉山采药时，经常去县城行走。一日遇见了曾经患浮肿病的教书先生，他感到疑惑不解，心想，比人曾经病情危重，户经无法治疗了，如今却像个健康人，他是吃了什力灵丹妙药呢?经过询问才知，他是喝了异样的"蘑菇"汤治好的。</p>
					<img src="../../assets/images/pager5img.png" />
					<p>&ensp;&ensp;原来峨眉山有个破庙里住着母女二人，母亲常年患病，女儿名叫灵芝，年方十六。为了维持生活，灵芝天天到山上采蘑菇，再掌到县城去卖。由于灵芝采蘑菇有经验，而且价格很便宜，买的人自然很多。有—天，她在山林深处枯树下，发现了三个异样的"酵菇"，形状像把小企，盖有碗口大，把有半尺长，额色红紫发亮。到城里去卖蘑菇时，她也顺便把那三个"蘑菇"带去，但没人买。直</p>
				</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>至有一年冬天，她卖完蘑菇准备回家时，有个青年跑来说，他父亲病了好多年，病危中忽然想起要吃蘑菇。不料姑娘已将蘑菇卖光了，就只剩下那三个异样的"蘑菇"，青年便买了急忙杆回家。后来昏迷的老人喝了"蘑菇"汤，第一天居然醒了过来，—连喝了三天，音然奇迹出现，病情好转，而目还能到街上转悠了。</p>
						<p>&ensp;&ensp;孙思邈听了这件事感到非常惊奇，便找到买蘑菇的青年，上山探访了灵芝姑娘，并把她采摘奇异蘑菇的经过和蘑菇的形态全部阳细地记录下来。待天气转后，他同徒弟们去山上寻找，终干将"蘑菇"找到了，于是便用姑娘的名字命名，称之为"灵芝草"。</p>
						<p>&ensp;&ensp;中医认为，灵芝性味甘平，为多孔菌科植物紫芝或赤芝的全株，具有滋补强壮、扶正固本、增强免疫力、延缓衰老的功力效。可治疗冠心病、高脂血症、高血压、癌症、慢性肝炎、支气管炎、神经衰弱、失眠健忘等症。现代药理研究证实，灵芝可镇静安神，抗肿瘤，抗动脉粥样硬化，抗血栓，抗衰老，并有降血脂、降血糖的作用。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>偶然识川芎</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;传说孙思邈有一日到青城山上采药，师徒们在混元顶松林中休息时，发现不远处有一只雌鹤，卧倒在地，好像生病了，旁边几只幼鹤在哀鸣，过了一会儿，空中飞来一只白鹤，嘴里叼着几株草药，从高空落下，幼鹤便急忙把药送去，病鹤吃药后不久，病果然好了。孙思邈感到很意外，将散落的药与自己采的药进行对照，才知这药是川芎，具有活血止痛作用。于是他不禁吟道：川西青城天下幽，神仙洞府第一流，白鹤巧衔送仙药，来自苍穹云霄头。</p>
						<img src="../../assets/images/pager6img.png" />
						<p>&ensp;&ensp;川芎为伞形科植物川芎的根茎。功能活血行气，祛风止痛。主治气滞血瘀之胁肋疼痛、月经不调、风湿痹痛等。现代药理实验表明能扩张冠状动脉，增加冠脉血流量及心肌营养血流量，增强心脏收缩力，</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>改善心脑供氧，以及镇静、解痉、抗菌、抗癌、抗辐射等作用。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>苦觅老鹳草</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;相传孙思邈在四川峨眉山时，遇到一位40多岁的男子前来求医。病人住在岷江岸边，长年以打鱼为生，天久日长得了风湿病。每当天寒阴湿时便两腿关节僵硬，行动非常不便。他先用自己配制的药为其治疗，当时服用有效，可过了一段时间后又复发。于是他又到山上采摘治病的草药，却令他十分失望。有一天到山上采药，无意间看到一只老鹳在山崖上啄食一种草，他想老鹳长年累月在江河湖泊中，时时遭受阴湿之气侵袭，为何不得风湿病？莫非它啄食的草有治疗风湿的功效？于是他迅速攀上山崖，将老鹳啄食的那种草采回，用水熬成药汁，让病人服下。结果初服后即感到疼痛减轻，继续服用红肿消退，能自主走路。他深为找到能治疗风湿的草药而高兴，可是不知道这种草药叫什么，他想这是老鹳帮自己找到的药，所以便给此药命名为“老鹳草”。</p>
						<p>&ensp;&ensp;老鹳草为牻牛儿苗科植物老鹳草的全草。性味辛、苦，平。功能祛风除湿，疏经活络，止泻治痢。主治风湿痹痛，麻木拘挛，</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<img src="../../assets/images/pager7img.png" />
						<p>筋骨酸痛，泄泻痢疾等。现代药理证实全草煎剂对卡他球菌、金黄色葡萄球菌、福氏痢疾杆菌、乙型链球菌、肺炎球菌及亚洲甲型流感病毒京科68-1株和副流感病毒Ⅰ型仙台株有明显抑制作用；尚有止泻、抗炎、抗癌作用。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>梓州治消渴</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;唐贞观十年（公元636年），梓州刺史李文博因久服丹石，患了消渴，小便频数，昼夜百行，证属阴虚火旺。孙思邈给他开了黄连丸，服药后症状明显好转。但他又因房劳过度，导致消渴之病加重，体质羸瘦，精神恍惚，口舌焦干而死。孙思邈对此颇为遗憾，并告诫后人∶患消渴病，其所慎者有三∶—饮酒，二房室，三咸食及面，能慎此者，虽不服药而自可无他;不知此者，纵有金丹亦不可救。</p>
						<img src="../../assets/images/pager8img.jpg" />
						<p>他的论断至今看来也是非常科学的。因此在《备急千金要方·卷二十一》中，孙思邈不但对消渴病有详细的观察和描述，而且对其并发症如肺部感染、心血管病等也有详细论述。收载治疗此病的方剂有75首，药物达129种。可</p>
						
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>见他对此病有较深的研究。消渴病类似现代医学的糖尿病，是一种全身慢性代谢性疾病。</p>
						<img src="../../assets/images/pager8img2.png" />
						<p>&ensp;&ensp;黄连丸由黄连、生地黄组成，研末制蜜丸服，有清热泻火、生津止渴作用。而其它方中，以栝楼根、地骨皮、生石膏、黄芪、麦冬、茯苓等出现频率最高，对后世治疗糖尿病的组方用药产生了深远影响。</p>
						
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>公布屠苏酒</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;唐朝初年南方时有瘟疫发生，孙思邈在常州一带行医，不舍昼夜抢救病人。经过半个月的努力，瘟疫得到有效的控制。然而过了不久，又从小孩到大人流行起来。为了长期地预防和治疗此病，他经过潜心研究，发现葛洪《肘后备急方》中有预防瘟疫的药方——“屠苏酒”。他便精心配制药酒，让未得病的人喝，结果瘟疫再也没有发生。他为了普及防疫知识，便找来一大张黄绢，把药物组成及炮制方法全部写在上边，张榜公布在屠苏庵山门的柱子上，让人们广泛传抄。</p>
						<img src="../../assets/images/pager9img.png" />
						<p>后来岁末饮“屠苏酒”，便成为江南各地流行的习俗，而且还传到日本等国。自此人们对他这种重视普及、从不保守的可贵精神大力传诵。</p>
						<p>&ensp;&ensp;屠苏酒由大黄、川椒、白术、桂心、桔梗、乌头、菝葜等组成。原方制法是将药细</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>切，以绢囊包贮，十二月晦日正中时悬至井中至泥，正月朔旦取药，置酒中，煮数沸，先从小量饮起，多少不拘。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>命名“阿是穴”</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;终南山里有位老猎人，由于长年在外，得了腿痛病，发作时难以忍受。他多方求医无效，后来听说长安城有个“药王”孙思邈，医术非常高明，于是他来到长安求医。孙思邈就给他服药、扎针，但治了将近半个月，病却不见好转，他想，除了针十四经穴，是不是可以另寻新穴呢？他又担心会出什么危险，就先在自己身上试扎了数次。</p>
						<img src="../../assets/images/pager10img.jpg" />
						<p>然后请老猎人躺在炕上，手指在腿上一分一寸地掐试针穴，并不停地问这里疼不疼？老猎人回答不是……当他掐到有个穴位时，老猎人突然大喊：“啊，是！”孙思邈便掐住这个点，毫不犹豫地把银针扎入这个穴位，过了一会儿，老猎人腿痛减轻了。因为疗效显著，孙思邈就记下这个新穴位。第二天又找到了一个点，就这样扎了7天针，换了5个穴位，老猎人的</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>腿痛病终于痊愈了。此后，孙思邈思忖给这些新穴位命名，忽然想起老猎人的喊声，于是就将这些经外奇穴称为“阿是穴”，而且一直沿用至今。</p>
						<p>&ensp;&ensp;“阿是穴”始于《备急千金要方》：“有阿是之法，言人有病痛，即令捏其上，若里当其处，不问孔穴，即得便成痛处，即云阿是。灸刺借验，故云阿是穴也。”因其无固定名称与位置，以病痛局部或压痛点为腧穴，故有疏通经络、运行气血的作用。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>彩绘明堂图</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;唐代贞观年间，孙思邈奉敕修“明堂图”。就是把人体脉穴绘成图像，以便医生学习。他与承务郎司马德逸、太医令谢季卿、太常丞甄立言共同承担校定经穴图的任务。</p>
						<img src="../../assets/images/pager11img.png" />
						<p>在此期间，他向专长针灸脉理的医学家甄权请教。甄权说：人体经络复杂难辨，自己从18岁研究孔穴，至今百岁已过，仍有许多疑问难以解决。孙思邈也发现古之“明堂图”错误甚多。于是他参照甄权所绘的针灸明堂图，又参考了大量的医学文献，进行反复研究，并亲手绘成了第一部仰人、背人、侧人的彩色《明</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="front">
					<div class="text">
						<p>堂三人图》，形象直观地绘出这些经穴的准确位置，使人能够一目了然。这便是我国最早绘制的彩色经络腧穴图。</p>
						<p>&ensp;&ensp;孙思邈云：“其十二经脉，五色作之，奇经八脉以绿色为之，三人孔穴共六百五十穴，图之于后，亦睹之便令了耳。”其中仰人282穴，背人194穴，侧人174穴，穴名共349个，单穴48个，双穴301个。可谓精心细致，详尽明了。</p>
					</div>
				</div>
				<div class="back">
					<div class="text">
						<div class="texttitle"><span>创制抓药柜</span><img class="titlebag" src="../../assets/images/titleswiperbag.png"/></div>
						<p>&ensp;&ensp;孙思邈在太白山采集中草药，他不畏艰险、翻山越岭，或穿越茂密的森林，或攀登峻陡的山崖，由于所采之药很多，加之性味功效不同，因此放置不能混杂。为了便于分类使用，他就让老妻特意用布做了一个褡裢，在上面缝制了许多小口袋，凡采到一种中草药，就装到一个小口袋里，便于回家后整理和使用。就是平时背在肩上，看病用药也十分便利。由于他看病时，总要把药从褡裢的小口袋里，一小撮一小撮地抓出来，时间一长，人们就习惯把此法称为“抓药”。</p>
						<img src="../../assets/images/pager12img.png" />
						<p>&ensp;&ensp;后来，孙思邈受到“抓药”的启发，依据褡裢的小袋子的方式，让木匠做成许多小格子，格子里又有小抽屉，将抽屉隔成三、四个方格，用来存放各种药材，外边写上中药名称，类似木制的箱柜，因此称为“药柜”。由于这种</p>
					</div>
				</div>
			</div>
			<div class="page1 noacti">
				<div class="text">
					<p>方式非常方便实用，所以一直沿用至今。现在的药柜一般有81个药斗，每斗分装4味药，取药比较方便。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				pageindex: 1
			}
		},
		mounted() {
			this.actives()
		},
		methods: {
			xyy() {
				
			},
			syy() {
				
			},
			actives(){
				let activepage = document.getElementsByClassName('activepage')
				for (let i = 0; i < activepage.length; i++) {
					let str = 'z-index:'+(3+i)
					activepage[i].setAttribute('style',str)
				}
				let pages = document.getElementsByClassName('noacti')
				for (let i = 0; i < pages.length; i++) {
					let str = 'z-index:'+(2 - i)
					pages[i].setAttribute('style',str)
				}
			},
			setpagename(num){
				if(this.pageindex<num){//那么说明再往后翻this.pageindex-num页
					let pages = document.getElementsByClassName('page1')
					let ss = 0
					for (let i = this.pageindex; i < num; i++) {
						setTimeout(()=>{
							pages[i-1].className = 'page1 activepage'
							pages[i-1].setAttribute('style','z-index:13')
							this.actives()
						},ss)
						ss+=100
					}
				}else{//那么说明往前翻num-this.pageindex页
					let pages = document.getElementsByClassName('page1')
					let ss = 0
					for (let i = this.pageindex-1; i >= num; i--) {
						setTimeout(()=>{
							pages[i - 1].className = 'page1 noacti'
							pages[i - 1].setAttribute('style','z-index:-13')
							this.actives()
						},ss)
						ss+=100
					}
				}
				this.pageindex = num
			}
		}
	}
</script>

<style scoped>
	.front .text{
		padding-left: 4rem;
	}
	.text>img{
		float: right;
		border: 5px solid #FFFFFF;
		width: 50%;
		margin: 10px;
	}
	.texttitle{
		position: relative;
		text-align: center;
		height: 4rem;
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
	}
	.titlebag{
		height: 4rem;
		position: absolute;
		margin: auto;
		left: 4rem;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: -1;
	}
	.texttitle span{
		line-height: 4rem;
		letter-spacing: 0.5rem;
		font-size: 1.4rem;
		font-weight: bold;
	}
	.text{
		padding: 4rem 2rem;
		    line-height: 1.8rem;
		    font-size: 1rem;
		    letter-spacing: 0.55rem;
		    color: #637279;
		    text-align: left;
	}
	.activepage{
		transform: perspective(1000px) rotateY(-180deg) !important
	}
	.firshpage {
		position: absolute;
		width: 50%;
		top: 0;
		left: 0;
		bottom: 0;
	}

	.pager {
		position: absolute;
		top: 0;
		left: 5rem;
		right: 5rem;
		bottom: 0;
		z-index: 2;
	}

	#box {
		width: 100%;
		height: 100%;
		position: relative;
	}

	/* 设定page的位置 */
	#box .page1 {
		/* 因为其在展示区右侧，所以宽度为整个box的一般，并定在右侧 */
		width: 50%;
		height: 100%;
		top: 0;
		right: 0;
		position: absolute;
		/* 将开启3d空间，方便翻页后front和back的3d变换 */
		transform-style: preserve-3d;
		/* 奇点设为左边 */
		transform-origin: left center;
		/* 设置翻书（旋转）的运动时间，运动形式 */
		transition: 1s all ease;
		/* 提升层级否则会被盖住 */
		z-index: 2;
		/* 设置景深来更好的展示3D效果，并给旋转角度一个初始值，防止抖动发生 */
		transform: perspective(800px) rotateY(0deg);
	}
.activepage .front{
		z-index: 1;
	}
	/* 配置旋转页的前页 */
	.front {
		/* 宽高与父级page一样 */
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		/* 将背景设成为与前一页相同的背景,并且只要右面的那部分，与页面左部分拼接 */
		background: url(../../assets/images/pagebag2.png) no-repeat;
		background-size: 100% 100%;
		/* backface-visibility属性和3D transform效果相关，它决定当一个元素的背面面是否可见 */
		backface-visibility: hidden;
		/* 提升层级否则会被盖住 */
		z-index: 2;
	}
	.activepage .back{
		z-index: 2;
	}
	/* 配置旋转页的后页 */
	.back {
		/* 宽高与父级page一样 */
		width: 100%;
		height: 100%;
		/* 将背景设成为与下一页相同的背景,并且只要左面的那部分，与右部分的page2拼接 */
		background: url(../../assets/images/pagebag.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: 0;
		top: 0;
		/* 这里设置将back进行水平方向上的镜像变化，因为当page旋转180°后， back显示的效果不对*/
		transform: scale(-1, 1);
		/* 改变层级避免盖住其他页面 */
		z-index: 1;
	}
	
	/* 配置pages展示区 */
	#box .page2 {
		/* 因为其只在页面右侧展示所以宽为Box的一半 */
		width: 50%;
		height: 100%;
		top: 0;
		right: 0;
		position: absolute;
		/* 将背景设成为与下一页相同的背景,并且只要右面的那部分，与左部分（.page .back）拼接 */
		background: url(../../assets/images/pagebag.png) no-repeat;
		background-size: 378.35px 550px;
		/* 改变层级避免盖住其他页面 */
		z-index: 1;
	}
</style>
